import { Button } from '#/components/ui/Button';
import { RichText } from '#/components/ui/RichText';
import { disclosureStatement } from '#/content/disclosure-statement';
import { useDefinitionDrawer } from '#/context/DefinitionDrawerContext';

/** Render the same trusted disclosure HTML used by the drawer. */
export function DisclosureStatementText({ className }: { className?: string }) {
  return (
    <RichText
      html={disclosureStatement.expandedDefinition}
      className={className}
    />
  );
}

/** Section-header action that opens the disclosure statement in the drawer. */
export function DisclosureStatementButton({
  trackContext,
}: {
  /**
   * Analytics grouping bucket (`data-track-context`). This button is a shared
   * section-header action, so the parent passes the section it appears in.
   */
  trackContext?: string;
}) {
  const { open } = useDefinitionDrawer();

  return (
    <Button
      prefixIcon="octagon-check"
      variant="link"
      onClick={() => open(disclosureStatement.slug)}
      data-track="disclosure_statement"
      data-track-context={trackContext}
    >
      {disclosureStatement.name}
    </Button>
  );
}
